import { useNavigate } from "react-router-dom";
import { auth, db } from "../Firebase";
import firebase from "firebase";
import { useEffect } from "react";

export default function AdminLogin() {

    const navi = useNavigate();

    function loginform(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var email = data.get("email");
        var password = data.get("password");

        if (email == "fitnessexpert@gmail.com") {
            auth.signInWithEmailAndPassword(email, password).then((userCredential) => {
                var user = userCredential.user;
                db.collection("admin")
                    .doc(user.uid)
                    .update({
                        lastLogin: firebase.firestore.FieldValue.serverTimestamp()
                    })
                navi("/admin/Dashboard");
            }).catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                alert("Wrong Email or Password")
            })
        } else {
            alert("Only admins allowed")
        }
    }

    function checklogin() {
        auth.onAuthStateChanged((user) => {
            // remove db collections/create db collection than check in loginform(), logincheck()
            if (user) {
                db.collection("admin").doc(user.uid).get().then((doc) => {
                    if (doc.exists && doc.data().role === "admin") {
                        navi("/admin/Dashboard");
                    } else {
                        auth.signOut();
                        console.log("nooooo");
                    }
                })
            }
        })
    }

    useEffect(() => {
        checklogin();
    }, [])

    return (
        <>
            <div className="d-flex justify-content-center align-items-center vh-100 bg-dark">
                <div className="col-lg-3 card bg-dark-subtle shadow p-4">
                    <div className="d-flex align-items-center justify-content-center">
                        <h4 className="fw-bold">Admin Login</h4>
                    </div>
                    <form onSubmit={loginform}>
                        <div className="mb-3">
                            <label className="text-dark small">Email</label>
                            <input name="email" type="email" placeholder="Enter Email" className="form-control rounded-3 py-2" />
                        </div>
                        <div className="mb-3">
                            <label className="text-dark small">Password</label>
                            <input name="password" type="password" placeholder="Enter Password" className="form-control rounded-3 py-2" />
                        </div>
                        <button type="submit" className="btn btn-success form-control mb-2">Login</button>
                        <p className="text-muted text-center">Only authorized admins can access this panel</p>
                    </form>
                </div>
            </div>
        </>
    )
}